<template>
  <div>
    <Produce />
  </div>
</template>

<script>
// 获取接口地址
import Produce from '../components/scrk/produce.vue'

export default {
  name: 'Scrk',
  components: {
    // sideMenu,
    // Header,
    Produce
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
